import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tg-button-footer.svg")